import { render } from "./SystemAcademicAssignmentsContent.vue?vue&type=template&id=dce4180e&ts=true"
import script from "./SystemAcademicAssignmentsContent.vue?vue&type=script&lang=ts"
export * from "./SystemAcademicAssignmentsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__